export const INIT_APP = "INIT_APP";

// Multi Middleware
export const MULTI = "MULTI";

// Api middleware
export const API_START = "API_START";
export const API_END = "API_END";

// City constants
export const ADD_CITY = "ADD_CITY";
export const FETCH_CURRENT_WEATHER = "FETCH_CURRENT_WEATHER";
export const FETCH_CURRENT_WEATHER_PENDING = "FETCH_CURRENT_WEATHER_PENDING";
export const FETCH_CURRENT_WEATHER_SUCCESS = "FETCH_CURRENT_WEATHER_SUCCESS";
export const FETCH_CURRENT_WEATHER_ERROR = "FETCH_CURRENT_WEATHER_ERROR";
export const SET_CURRENT_WEATHER = "SET_CURRENT_WEATHER";
export const DELETE_CITY = "DELETE_CITY";
export const UPDATE_ALL_WEATHER = "UPDATE_ALL_WEATHER";

// Toasts
export const CREATE_TOAST = "CREATE_TOAST";
export const DELETE_LAST_TOAST = "DELETE_LAST_TOAST";

export const TOGGLE_THEME = "TOGGLE_THEME";

export const ADD_CITY_WINDOW_OPEN = "ADD_CITY_WINDOW_OPEN";
export const ADD_CITY_WINDOW_CLOSE = "ADD_CITY_WINDOW_CLOSE";
